module.exports = __webpack_public_path__ + "static/media/PR6.b0d69b32.jpg";